var React = require('react');

function MinusMini (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"9","cy":"9","r":"8","fill":"white","stroke":"black","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M13 9.99992V8L5 7.99993V9.99992H13Z","fill":"black","key":1})]);
}

MinusMini.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = MinusMini;

MinusMini.default = MinusMini;
